// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1K4k-","video":"style_video__U9Qkb","fallback":"style_fallback__2JeHR"};